import videojs from 'video.js';
import document from 'global/document';
import HlsUtils from './_hls-utils';
import '../../node_modules/videojs-swf/dist/video-js.swf';

const Flash = videojs.getComponent('Flash');

const isFlashlsSwfAvailable = () => {
  return videojs.options.flash.swf && videojs.options.flash.swf.indexOf('flashls') !== -1;
};

Flash.registerSourceHandler({
  canHandleSource: (source) => {
    if (
      source.hasOwnProperty('data-disable-flashls') &&
      source['data-disable-flashls'] !== 'false' &&
      source['data-disable-flashls'] !== false &&
      source['data-disable-flashls'] !== '0' &&
      source['data-disable-flashls'] !== 0
    ) {
      return '';
    }
    if (!isFlashlsSwfAvailable()) {
      return '';
    }
    return HlsUtils.isHlsSource(source);
  },

  canPlayType: (type) => {
    if (!isFlashlsSwfAvailable()) {
      return '';
    }
    return HlsUtils.isHlsType(type);
  },

  handleSource: (source, tech) => {
    Flash.nativeSourceHandler.handleSource(source, tech);
  }
}, 0 /* source handler position */);


// Настройки по-умолчанию
videojs.options.flash.flashVars = videojs.options.flash.flashVars || {};

// v0.4.1.1 of mangui/video-js.swf is broken when capleveltostage=true, where it only plays the first level in the
//  playlist regardless of the bandwidth it can handle, so we set capleveltostage=false.
//  more info can be found here: https://github.com/mangui/flashls/issues/351
videojs.options.flash.flashVars.hls_capleveltostage = false;

// with v0.4.1.1 the seeking would jump pretty far back, so switching the mode to be more accurate versus using
//   the closest keyframe
videojs.options.flash.flashVars.hls_seekmode = 'ACCURATE';

// Попытаемся определить текущий элемент script для автоматического определения ссылки на swf файл
let currentScript;
if (document.currentScript) {
  currentScript = document.currentScript;
} else if (document.querySelector) {
  currentScript = document.querySelector('script[src*="videojs.bundle.js"]');
}

if (currentScript && currentScript.src) {
  videojs.options.flash.swf = currentScript.src.replace('videojs.bundle.js', 'videojs.flashls.swf');
}



// WEBPACK FOOTER //
// ./src/source-handlers/flash-flashls-handler.js